// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Multipaz Developer Tools Style Sheet */
body {
    background-color: #0f172a;
}
`, "",{"version":3,"sources":["webpack://./kotlin/style.css"],"names":[],"mappings":"AAAA,yCAAyC;AACzC;IACI,yBAAyB;AAC7B","sourcesContent":["/* Multipaz Developer Tools Style Sheet */\nbody {\n    background-color: #0f172a;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
